import '@nettbureau/theme';
import 'radash';
import 'polished';
import { parseStrokeColor } from '../parsers/stroke-color.js';

/**
 * Generates CSS for applying an outline to an element.
 *
 * @param options - Options for the mixin.
 */ function outline({ outline = 'neutral', outlineTone = 'none', outlineWidth = 'regular' }) {
    return (theme)=>({
            boxShadow: `inset 0 0 0 ${theme.strokeWidths[outlineWidth]}px ${parseStrokeColor(theme, outline, outlineTone)}`
        });
}

export { outline };
//# sourceMappingURL=outline.js.map
